<script lang="ts">
	import type { ButtonSize } from './button';

	// All creativity credited to
	// https://github.com/Schum123/svelte-loading-spinners/blob/29a0fe697889b00554094323e7bf419f0dd20c8e/src/lib/Pulse.svelte
	export let color = '#fff';
	export let duration = 1.5;
	export let size: ButtonSize = 'md';

	const sizeNumberLookup: Record<ButtonSize, number> = {
		xxs: 1,
		xs: 1,
		sm: 1.25,
		md: 1.5,
		lg: 1.75,
		xl: 2
	};

	$: sizeNumber = sizeNumberLookup[size];
</script>

<span
	class="relative flex justify-center align-center sizer"
	style="--size: {sizeNumber}rem; --color: {color}; --duration: {duration}s">
	{#each Array(3) as _, i}
		<span
			class="rect"
			style="animation-delay: {i * (duration / 10)}s; left: {i *
				(sizeNumber / 3 + sizeNumber / 15)}rem;" />
	{/each}
</span>

<style>
	.sizer {
		width: var(--size);
		height: calc(var(--size) / 2.5);
	}
	.rect {
		position: absolute;
		top: 0px;
		width: calc(var(--size) / 5);
		height: calc(var(--size) / 2.5);
		background-color: var(--color);
		animation: motion var(--duration) cubic-bezier(0.895, 0.03, 0.685, 0.22)
			infinite;
	}
	@keyframes motion {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
</style>
